import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'

interface Team {
  id: string | number
  name: string
  users_count: number
  created_at: string
}

const fetchTeams = async (orgId: string): Promise<Team[]> => {
  const response = await fetch(
    `${BASE_API_URL}/admin/api/v2/organizations/${orgId}/teams`,
    {
      method: 'GET',
      headers: apiHeaders(store.getState()),
    }
  )
  const handledResponse = handleErrors(response)
  const data = await handledResponse.json()
  return data?.data?.teams || []
}

export const useFetchTeams = (orgId?: string) => {
  return useQuery(['teams', orgId], () => fetchTeams(orgId!), {
    enabled: !!orgId,
    refetchOnWindowFocus: false,
  })
}
